export const normalizeUserSpotlightSectionType = (type: string) => {
	return (
		type
			.trim()
			// Convert camelCase/PascalCase to snake_case
			.replace(/([a-z0-9])([A-Z])/g, '$1_$2')
			// Normalize separators
			.replace(/[-\s]+/g, '_')
			.toLowerCase()
	);
};

export const titleCaseWords = (snake: string) => {
	return snake
		.split('_')
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

export const getUserSpotlightSectionTypeKey = (type: string): string => {
	return normalizeUserSpotlightSectionType(type);
};

export const getUserSpotlightSectionTypeLabelFallback = (type: string): string => {
	return titleCaseWords(getUserSpotlightSectionTypeKey(type));
};
